import { Controller, useFormContext } from 'react-hook-form';
import { useLocalization } from '@ui-framework/index';
import React, { forwardRef, useEffect } from 'react';
import { Box } from '@mui/material';
import MultiValueSelector from './MultiValueSelectorDependent';
import rulesFormatter from '../utils/rulesFormatter';

const MultiValueSelectorController = forwardRef((props, ref) => {
  const { control, watch, setValue } = useFormContext();
  const { formatMessage } = useLocalization();
  const { field } = props;

  const dependentOn = Object.values(field.dependencies || {});
  let dependentOnValues = [];
  if (Array.isArray(dependentOn) && dependentOn.length === 1) {
    const { key, defaultMessage } = dependentOn[0];
    dependentOnValues = watch(key);

    useEffect(() => {
      if (dependentOnValues === null) {
        setValue(props.name);
      }
    }, [dependentOnValues]);

    if (
      dependentOnValues === null ||
      dependentOnValues === undefined ||
      (Array.isArray(dependentOnValues) && dependentOnValues.length === 0)
    ) {
      return defaultMessage;
    }
  }
  return (
    <Box ref={ref}>
      <Controller
        name={props?.name}
        control={control}
        render={({ field: controllerField }) => {
          return (
            <MultiValueSelector
              title={formatMessage({
                id: field.label.localeId,
                defaultMessage: field.label.defaultMessage,
              })}
              value={controllerField?.value}
              onChange={data => {
                controllerField.onChange(data);
              }}
              valueFormatter={rulesFormatter}
              leftNameKey={field?.leftNameKey}
              leftValueKey={field?.leftValueKey}
              rightValueKey={field?.rightValueKey}
              limit={10}
              dependentOnValues={dependentOnValues}
              getLeftItemsUrl={field.api}
              searchNameKey={field?.searchNameKey}
              leftTitle={formatMessage({
                id: field.label.localeId,
                defaultMessage: field.label.defaultMessage,
              })}
            />
          );
        }}
      />
    </Box>
  );
});

export default MultiValueSelectorController;
